// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"39cd1472","239":"3db7bcf7","453":"f00aa59d","732":"e81b0229"}[chunkId] + ".chunk.js";
};